import {APP_INITIALIZER, ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter, withComponentInputBinding, withViewTransitions} from '@angular/router';

import {MainRoutes} from './app.routes';
import {HttpClientModule, provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideAnimations} from '@angular/platform-browser/animations';
import {AuthService, LOGIN_ROUTE} from "./modules/auth";
import {appInterceptorFn} from "./shared/interceptor/interceptors";
import {DatePipe} from "@angular/common";
import {DatePipeProvider, GlobalErrorHandlerProvider, LocaleProvider} from "./shared/provider";
import {provideEnvironmentNgxMask} from "ngx-mask";
import {lastValueFrom} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";
import {GraphQLModule} from "./graphql.module";
import {NgxUiLoaderModule, NgxUiLoaderRouterModule} from "ngx-ui-loader";
import {FLATPICKER_CONFIG, LOADER_UI_CONFIG} from "../_config/global";
import {InlineSVGModule} from "ng-inline-svg-2";
import {ToastrModule} from "ngx-toastr";
import {FlatpickrModule} from "angularx-flatpickr";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise(async (resolve) => {

      let response = await lastValueFrom(authService.getUserByToken()).catch(reason => reason)
      if (undefined === response?.id) {
        const refreshStatusResponse = await lastValueFrom(authService.refreshToken()).catch(reason => reason)
        if (undefined === refreshStatusResponse || refreshStatusResponse.hasOwnProperty('error')) {
          await authService.logout({
            redirectToCurrentUrl: true,
            reloadPage: false,
          });
        }

        response = refreshStatusResponse;
      }

      resolve(response);
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    provideAnimations(),
    provideRouter(
      MainRoutes,
      withViewTransitions(), //browser experimental feature only Chrome
      withComponentInputBinding(),
    ),
    provideHttpClient(withInterceptors([appInterceptorFn])),
    DatePipe,
    GlobalErrorHandlerProvider,
    LocaleProvider,
    DatePipeProvider,
    provideEnvironmentNgxMask(),
    importProvidersFrom(
      HttpClientModule,
      GraphQLModule,
      TranslateModule.forRoot(),
      InlineSVGModule.forRoot(),
      NgxUiLoaderModule.forRoot(LOADER_UI_CONFIG),
      NgxUiLoaderRouterModule.forRoot({exclude: [LOGIN_ROUTE]}),
      /* NgxUiLoaderHttpModule.forRoot({ showForeground: false }), */
      ToastrModule.forRoot(),
      FlatpickrModule.forRoot(FLATPICKER_CONFIG),
      NgxSkeletonLoaderModule.forRoot()
    ),
  ],
};
